import { TransactionListsWrapper } from 'components/account-center/styled'
import { useAtomValue } from 'jotai'
import React from 'react'
import { TransactionStatus } from 'sdk/omni/omni-transaction-service/types'
import { Transaction, bySingleChain, isPending, storedTransactionsAtom, useRefresh } from 'services'
import { useMultiTransactionState } from 'services/pending-transactions-context'
import { useAccount } from 'wagmi'
import { byAccount } from '../controllers/tx-controller'
import TransactionListWrapper from './wrappers/list-wrapper'
import PendingTransactionsListWrapper from './wrappers/pending-list-wrapper'

/**
 * Container component for transactions
 */
const TransactionsContainer: React.FC = () => {
  const [singleTransactions, setSingleTransactions] = React.useState<Transaction[]>([])
  const [multiTransactions, setMultiTransactions] = React.useState<Transaction[]>([])
  const { pending } = useMultiTransactionState()
  const { fastRefresh } = useRefresh()
  const transactions = useAtomValue(storedTransactionsAtom)

  const { address } = useAccount()
  /**
   * IT: sorts transactions account specific
   * WHEN: transactions or pending transactions change
   */
  React.useEffect(() => {
    if (!address) return
    const accountSpecificMulti = transactions
      .filter(byAccount(address))
      .filter(bySingleChain(false))
    const accountSpecificSingle = transactions
      .filter(byAccount(address))
      .filter(bySingleChain(true))

    setMultiTransactions(accountSpecificMulti)
    setSingleTransactions(accountSpecificSingle)
  }, [address, transactions, fastRefresh])

  return (
    <TransactionListsWrapper>
      <PendingTransactionsListWrapper
        transactionsPending={pending}
        transactionsFailed={transactions.some((tx) => tx.status === TransactionStatus.FAILED)}
        multiChainTransactions={multiTransactions.filter(isPending)}
        singleChainTransactions={singleTransactions.filter(isPending)}
      />
      <TransactionListWrapper />
    </TransactionListsWrapper>
  )
}

export default TransactionsContainer
